var map = {
	"./icon-arrow-up.svg": 326,
	"./icon-checkbox.svg": 327,
	"./icon-checkmark.svg": 328,
	"./icon-delete.svg": 329,
	"./icon-edit.svg": 330,
	"./icon-next.svg": 331,
	"./icon-prev.svg": 332,
	"./icon-star-selected.svg": 333,
	"./icon-star.svg": 334,
	"./investigation-1/clue-1.jpg": 335,
	"./investigation-1/clue-2.jpg": 336,
	"./investigation-1/clue-3.jpg": 337,
	"./investigation-10/clue-2.svg": 338,
	"./investigation-10/clue-4.svg": 339,
	"./investigation-12/clue-1.svg": 340,
	"./investigation-12/clue-2.svg": 341,
	"./investigation-12/clue-3.svg": 342,
	"./investigation-12/clue-4.svg": 343,
	"./investigation-12/clue-5.svg": 344,
	"./investigation-12/clue-6.svg": 345,
	"./investigation-12/clue-7.svg": 346,
	"./investigation-12/clue-8.svg": 347,
	"./investigation-12/clue-9.svg": 348,
	"./investigation-13/clue-3.svg": 349,
	"./investigation-14/clue-1.svg": 350,
	"./investigation-14/clue-2.svg": 351,
	"./investigation-2/clue-2.svg": 352,
	"./investigation-2/clue-3.svg": 353,
	"./investigation-2/clue-5.svg": 354,
	"./investigation-2/clue-7.png": 355,
	"./investigation-3/clue-1.svg": 356,
	"./investigation-5/clue-2.svg": 357,
	"./investigation-6/clue-1.svg": 358,
	"./investigation-7/clue-1.svg": 359,
	"./investigation-8/clue-1.svg": 360,
	"./investigation-8/clue-2.svg": 361,
	"./investigation-8/clue-3.svg": 362,
	"./investigation-8/clue-4.svg": 363,
	"./investigation-9/clue-1.svg": 364,
	"./investigation-9/clue-2.svg": 365,
	"./investigation-9/clue-3.svg": 366,
	"./next-step-button.svg": 367,
	"./striped-background.png": 368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 889;